import { Injectable, effect, inject, signal } from '@angular/core';
import { NotificationService } from 'app/core/services/notifications/notification.service';
import { NotificationHubService } from 'app/core/services/notifications/notification-hub.service';

@Injectable({ providedIn: 'root' })
export class NotificationStoreService {
  private readonly api = inject(NotificationService);
  private readonly hub = inject(NotificationHubService);

  readonly loading = signal(false);

  // Badge global
  readonly unreadCount = signal<number>(0);

  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.refreshUnread();

    effect(() => {
      const incoming = this.hub.notifications();
      if (!incoming.length) return;

      // incrementa badge inmediatamente
      this.unreadCount.update(v => v + 1);

    });
  }

  refreshUnread(): void {
    this.api.getUnreadNotifications().subscribe({
      next: (resp) => this.unreadCount.set(resp.unread ?? 0),
    });
  }
}